
export class CotizacionRequest{

  constructor(
  public pair_id?: number,
  public mount_sell?: number,
  public mount_buy?: number
  ){}
}
